import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../ApiSetup/Axios";
import {
  ApiDelete,
  ApiGet,
  ApiGetBlob,
  ApiGetNoAuth,
  ApiPost,
  ApiPostNoAuth,
  ApiPostText,
  ApiPut,
} from "../../ApiSetup/Api";

/** Unwrap axios response; propagate errors as rejected thunks */
const callApi = (promise) =>
  promise.then((response) => {
    if (response?.cancelled) {
      return Promise.reject({ cancelled: true });
    }
    return response?.data;
  });

export const login = createAsyncThunk("login", async (body) => {
  return callApi(ApiPostNoAuth(api?.login, body));
});

export const verifyOtp = createAsyncThunk("verifyOtp", async (body) => {
  return ApiPostNoAuth(api?.verifyOtp, body)
    .then((response) => response?.data)
});

// -----------------------------------  Layout  -----------------------------------
//get Available access
export const getAvailableAccess = createAsyncThunk(
  "getAvailableAccess",
  async (body) => {
    return ApiGet(api?.getAvailableAccess, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  Add Member  -----------------------------------

// upload Image
export const uploadImage = createAsyncThunk("uploadImage", async (body) => {
  return ApiPost(api?.uploadImage, body)
    .then((response) => response?.data)
});

// delete File Image
export const deleteFile = createAsyncThunk("deleteFile", async (body) => {
  return ApiPost(api?.deleteFile, body)
    .then((response) => response?.data)
});

// -----------------------------------  Add Member  -----------------------------------

// add Member
export const addMember = createAsyncThunk("addMember", async (body) => {
  return ApiPost(api?.addMember, body)
    .then((response) => response?.data)
});

//getLocationByPincode
export const getLocationByPincode = createAsyncThunk(
  "getLocationByPincode",
  async (body) => {
    return ApiPost(api?.getLocationByPincode, body)
      .then((response) => response?.data)
  }
);

// get Member
export const getMember = createAsyncThunk("getMember", async (body) => {
  return ApiGet(api?.getMember + body)
    .then((response) => response?.data)
});

export const downloadMemberApplicationPdf = createAsyncThunk(
  "downloadMemberApplicationPdf",
  async (memberId) => {
    return ApiGetBlob(`${api?.downloadMemberApplicationPdf}${memberId}/application-pdf`)
      .then((response) => response)
  }
);

// update Member
export const updateMember = createAsyncThunk("updateMember", async (body) => {
  return ApiPut(api?.updateMember, body)
    .then((response) => response?.data)
});

// -----------------------------------  settings / general  -----------------------------------
// getForm
export const getForm = createAsyncThunk("getForm", async (body) => {
  return ApiGet(api?.getForm, body)
    .then((response) => response?.data)
});

// createFields
export const createFields = createAsyncThunk("createFields", async (body) => {
  return ApiPost(api?.createFields, body)
    .then((response) => response?.data)
});

// deleteFields
export const deleteFields = createAsyncThunk("deleteFields", async (body) => {
  return ApiDelete(api?.deleteFields, body)
    .then((response) => response?.data)
});

// getDataById
export const getDataById = createAsyncThunk("getDataById", async (body) => {
  return ApiPost(api?.getDataById, body)
    .then((response) => response?.data)
});

// updateFields
export const updateFields = createAsyncThunk("updateFields", async (body) => {
  return ApiPut(api?.updateFields, body)
    .then((response) => response?.data)
});

// -----------------------------------  settings / User & Role  -----------------------------------
//get role access
export const get_role_access = createAsyncThunk(
  "get_role_access",
  async (body) => {
    return ApiGet(api?.get_role_access, body)
      .then((response) => response?.data)
  }
);

//get available access
export const get_available_access = createAsyncThunk(
  "get_available_access",
  async (body) => {
    return ApiGet(api?.get_available_access, body)
      .then((response) => response?.data)
  }
);

// add role access
export const add_role_access = createAsyncThunk(
  "add_role_access",
  async (body) => {
    return ApiPost(api?.add_role_access, body)
      .then((response) => response?.data)
  }
);

// update role access
export const update_role_access = createAsyncThunk(
  "update_role_access",
  async (body) => {
    return ApiPut(api?.update_role_access, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  Page Management (Sidebar Configuration)  -----------------------------------
// get sidebar config (sections and icons)
export const get_sidebar_config = createAsyncThunk(
  "get_sidebar_config",
  async (body) => {
    return ApiGet(api?.get_sidebar_config, body)
      .then((response) => response?.data)
  }
);

// update page settings
export const update_page_settings = createAsyncThunk(
  "update_page_settings",
  async (body) => {
    return ApiPut(api?.update_page_settings, body)
      .then((response) => response?.data)
  }
);

// bulk update page settings
export const bulk_update_page_settings = createAsyncThunk(
  "bulk_update_page_settings",
  async (body) => {
    return ApiPut(api?.bulk_update_page_settings, body)
      .then((response) => response?.data)
  }
);

// add new page
export const add_new_page = createAsyncThunk(
  "add_new_page",
  async (body) => {
    return ApiPost(api?.add_new_page, body)
      .then((response) => response?.data)
  }
);

// delete page
export const delete_page = createAsyncThunk(
  "delete_page",
  async (body) => {
    return ApiDelete(api?.delete_page, body)
      .then((response) => response?.data)
  }
);

// get role access
export const get_dynamic_role_list = createAsyncThunk(
  "get_dynamic_role_list",
  async (body) => {
    return ApiGet(api?.get_dynamic_role_list, body)
      .then((response) => response?.data)
  }
);

// get_user_list
export const get_user_list = createAsyncThunk("get_user_list", async (body) => {
  return ApiPost(api?.get_user_list, body)
    .then((response) => response?.data)
});

// inactive_user_list
export const inactive_user_list = createAsyncThunk(
  "inactive_user_list",
  async (body) => {
    return ApiPost(api?.inactive_user_list, body)
      .then((response) => response?.data)
  }
);

// add_extra_userType
export const add_extra_userType = createAsyncThunk(
  "add_extra_userType",
  async (body) => {
    return ApiPost(api?.add_extra_userType, body)
      .then((response) => response?.data)
  }
);

// active_inactive_member
export const active_inactive_member = createAsyncThunk(
  "active_inactive_member",
  async (body) => {
    return ApiPost(api?.active_inactive_member, body)
      .then((response) => response?.data)
  }
);

// add Role
export const addRole = createAsyncThunk("addRole", async (body) => {
  return ApiPost(api?.addRole, body)
    .then((response) => response?.data)
});

// delete Role
export const deleteRole = createAsyncThunk("deleteRole", async (body) => {
  return ApiPost(api?.deleteRole, body)
    .then((response) => response?.data)
});

// -----------------------------------  Stage Of Claims  -----------------------------------

//get Stage
export const getStage = createAsyncThunk("getStage", async (body) => {
  return ApiGet(api?.getStage, body)
    .then((response) => response?.data)
});

//create Stage
export const addStage = createAsyncThunk("addStage", async (body) => {
  return ApiPost(api?.addStage, body)
    .then((response) => response?.data)
});

//update Stage
export const updateStage = createAsyncThunk("updateStage", async (body) => {
  return ApiPut(api?.updateStage, body)
    .then((response) => response?.data)
});

//delete Stage
export const deleteStage = createAsyncThunk("deleteStage", async (body) => {
  return ApiDelete(api?.deleteStage + body)
    .then((response) => response?.data)
});

// ----------------------------------- Setting >> FAQ  -----------------------------------

//get FAQ
export const getFaqs = createAsyncThunk("getFaqs", async (body) => {
  return ApiPost(api?.getFaqs, body)
    .then((response) => response?.data)
});

//create FAQ
export const addFaqs = createAsyncThunk("addFaqs", async (body) => {
  return ApiPost(api?.addFaqs, body)
    .then((response) => response?.data)
});

//update FAQ
export const updateFaqs = createAsyncThunk("updateFaqs", async (body) => {
  return ApiPut(api?.updateFaqs, body)
    .then((response) => response?.data)
});

//delete FAQ
export const deleteFaqs = createAsyncThunk("deleteFaqs", async (body) => {
  return ApiDelete(api?.deleteFaqs + body)
    .then((response) => response?.data)
});

// ----------------------------------- Setting >> Account  -----------------------------------
//get Account
export const getAccount = createAsyncThunk("getAccount", async (body) => {
  return ApiPost(api?.getAccount, body)
    .then((response) => response?.data)
});

//create Account
export const addAccount = createAsyncThunk("addAccount", async (body) => {
  return ApiPost(api?.addAccount, body)
    .then((response) => response?.data)
});

//update Account
export const updateAccount = createAsyncThunk("updateAccount", async (body) => {
  return ApiPut(api?.updateAccount, body)
    .then((response) => response?.data)
});

//delete Account
export const deleteAccount = createAsyncThunk("deleteAccount", async (body) => {
  return ApiDelete(api?.deleteAccount + body)
    .then((response) => response?.data)
});

// -----------------------------------  Documents  -----------------------------------

//get Documents

export const getDocuments = createAsyncThunk("getDocuments", async (body) => {
  return ApiPost(api?.getDocuments, body)
    .then((response) => response?.data)
});

//verify Documets
export const verifyDocuments = createAsyncThunk(
  "verifyDocuments",
  async (body) => {
    return ApiPost(api?.verifyDocuments, body)
      .then((response) => response?.data)
  }
);

//verify Documets
export const getDocumentsById = createAsyncThunk(
  "getDocumentsById",
  async (body) => {
    return ApiGet(api?.getDocumentsById + body)
      .then((response) => response?.data)
  }
);

//verify Documets
export const getMembersSummary = createAsyncThunk(
  "getMembersSummary",
  async (body) => {
    return ApiPost(api?.getMembersSummary, body)
      .then((response) => response?.data)
  }
);

// Get Deleted Users
export const getDeletedUsers = createAsyncThunk(
  "getDeletedUsers",
  async (body) => {
    return ApiPost(api?.getDeletedUsers, body)
      .then((response) => response?.data)
  }
);

// Restore Deleted User
export const restoreDeletedUser = createAsyncThunk(
  "restoreDeletedUser",
  async (body) => {
    return ApiPost(api?.restoreDeletedUser, body)
      .then((response) => response?.data)
  }
);

// Permanently Delete User (admin action — only for soft-deleted users)
export const permanentDeleteUser = createAsyncThunk(
  "permanentDeleteUser",
  async (body) => {
    return ApiPost(api?.permanentDeleteUser, body)
      .then((response) => response?.data)
  }
);

// Get Duplicate Accounts
export const getDuplicateAccounts = createAsyncThunk(
  "getDuplicateAccounts",
  async (body) => {
    return ApiPost(api?.getDuplicateAccounts, body)
      .then((response) => response?.data)
  }
);

// Merge Duplicate Accounts
export const mergeDuplicateAccounts = createAsyncThunk(
  "mergeDuplicateAccounts",
  async (body) => {
    return ApiPost(api?.mergeDuplicateAccounts, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  settings / Banner  -----------------------------------

//get Banner
export const getBanner = createAsyncThunk("getBanner", async (body) => {
  return ApiPost(api?.getBanner, body)
    .then((response) => response?.data)
});

//add Banner
export const addBanner = createAsyncThunk("addBenner", async (body) => {
  return ApiPost(api?.addBanner, body)
    .then((response) => response?.data)
});

//update Banner
export const updateBanner = createAsyncThunk("updateBanner", async (body) => {
  return ApiPut(api?.updateBanner, body)
    .then((response) => response?.data)
});

//delete Banner
export const deleteBanner = createAsyncThunk("deleteBanner", async (body) => {
  return ApiDelete(api?.deleteBanner + body)
    .then((response) => response?.data)
});

// -----------------------------------  settings / General Notifications  -----------------------------------

//get Notifications
export const getNotifications = createAsyncThunk(
  "getNotifications",
  async (body) => {
    return ApiPost(api?.getNotifications, body)
      .then((response) => response?.data)
  }
);

//add Notifications
export const addNotifications = createAsyncThunk(
  "addNotifications",
  async (body) => {
    return ApiPost(api?.addNotifications, body)
      .then((response) => response?.data)
  }
);

//update Notifications
export const updateNotifications = createAsyncThunk(
  "updateNotifications",
  async (body) => {
    return ApiPost(api?.updateNotifications, body)
      .then((response) => response?.data)
  }
);

//delete Notifications
export const deleteNotifications = createAsyncThunk(
  "deleteNotifications",
  async (body) => {
    return ApiDelete(api?.deleteNotifications + body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  settings / General Occupation  -----------------------------------

//get Notifications
export const getOccupation = createAsyncThunk("getOccupation", async (body) => {
  return ApiPost(api?.getOccupation, body)
    .then((response) => response?.data)
});

//add Notifications
export const addOccupation = createAsyncThunk("addOccupation", async (body) => {
  return ApiPost(api?.addOccupation, body)
    .then((response) => response?.data)
});

//update Notifications
export const updateOccupation = createAsyncThunk(
  "updateOccupation",
  async (body) => {
    return ApiPut(api?.updateOccupation, body)
      .then((response) => response?.data)
  }
);

//delete Notifications
export const deleteOccupation = createAsyncThunk(
  "deleteOccupation",
  async (body) => {
    return ApiDelete(api?.deleteOccupation + `/${body}`)
      .then((response) => response?.data)
  }
);

// -----------------------------------  settings / App Version -----------------------------------

// get App Version
export const getAppVersion = createAsyncThunk("getAppVersion", async (body) => {
  return ApiGet(api?.getAppVersion + body)
    .then((response) => response?.data)
});

// update App Version
export const updateAppVersion = createAsyncThunk(
  "updateAppVersion",
  async (body) => {
    return ApiPost(api?.updateAppVersion, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  settings / App Role & Permission -----------------------------------

// update App Role & Permission
export const update_application_role_permission = createAsyncThunk(
  "update_application_role_permission",
  async (body) => {
    return ApiPost(api?.update_application_role_permission, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  follwUp -----------------------------------
// get_all_followups
export const get_all_followups = createAsyncThunk(
  "get_all_followups",
  async (body) => {
    return ApiPost(api?.get_all_followups, body)
      .then((response) => response?.data)
  }
);

export const getDocumentAssigneeRoles = createAsyncThunk(
  "getDocumentAssigneeRoles",
  async (body) => {
    return ApiGet(api?.getDocumentAssigneeRoles, body)
      .then((response) => response?.data)
  }
);

export const assignMember = createAsyncThunk("assignMember", async (body) => {
  return ApiPost(api?.assignMember, body)
    .then((response) => response?.data)
});

// update_followup
export const update_followup = createAsyncThunk(
  "update_followup",
  async (body) => {
    return ApiPost(api?.update_followup, body)
      .then((response) => response?.data)
  }
);

// update_notInterestedStatus
export const update_notInterestedStatus = createAsyncThunk(
  "update_notInterestedStatus",
  async (body) => {
    return ApiPost(api?.update_notInterestedStatus, body)
      .then((response) => response?.data)
  }
);

// -----------------------------------  get Transaction History -----------------------------------

// get Transaction History
export const getTransactionHistory = createAsyncThunk(
  "getTransactionHistory",
  async (body) => {
    return ApiPost(api?.getTransactionHistory, body)
      .then((response) => response?.data)
  }
);

export const getParticularUserTransaction = createAsyncThunk(
  "getParticularUserTransaction",
  async (body) => {
    return ApiPost(api?.getParticularUserTransaction, body)
      .then((response) => response?.data)
  }
);

// ----------------------------------- Member Serach-----------------------------------

// getMember By Mobile Number
export const getMemberByMobileNumber = createAsyncThunk(
  "getMemberByMobileNumber",
  async (body) => {
    return ApiPost(api?.getMemberByMobileNumber, body)
      .then((response) => response?.data)
  }
);

// Get Transaction List
export const get_transaction_list = createAsyncThunk(
  "get_transaction_list",
  async (body) => {
    return ApiPost(api?.get_transaction_list, body)
      .then((response) => response?.data)
  }
);

export const app_get_role_access = createAsyncThunk(
  "app_get_role_access",
  async (body) => {
    return ApiGet(api?.app_get_role_access, body)
      .then((response) => response?.data)
  }
);

export const app_update_role_access = createAsyncThunk(
  "app_update_role_access",
  async (body) => {
    return ApiPut(api?.app_update_role_access, body)
      .then((response) => response?.data)
  }
);

export const active_inactive_member_Deactive = createAsyncThunk(
  "active_inactive_member_Deactive",
  async (body) => {
    return ApiPost(api?.active_inactive_member_Deactive, body)
      .then((response) => response?.data)
  }
);

export const get_all_organisations = createAsyncThunk(
  "get_all_organisations",
  async () => {
    return ApiGet(api?.get_all_organisations)
      .then((response) => response?.data)
  }
);

export const get_company_member_list = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.get_company_member_list, body)
      .then((response) => response?.data)
  }
);

export const get_company_members_summary = createAsyncThunk(
  "get_company_members_summary",
  async (body) => {
    return ApiPost(api?.get_company_members_summary, body)
      .then((response) => response?.data)
  }
);

export const update_company_member = createAsyncThunk("update_company_member", async (body) => {
  return ApiPost(api?.update_company_member, body)
    .then((response) => response?.data)
});

export const get_active_members = createAsyncThunk("get_active_members", async (body) => {
  return ApiPost(api?.get_active_members, body)
    .then((response) => response?.data)
});

export const get_active_members_summary = createAsyncThunk("get_active_members_summary", async (body) => {
  return ApiPost(api?.get_active_members_summary, body)
    .then((response) => response?.data)
});

export const export_active_members = createAsyncThunk("export_active_members", async (body) => {
  return ApiPost(api?.export_active_members, body)
    .then((response) => response?.data)
});

export const globalSearch = createAsyncThunk("globalSearch", async (body) => {
  return ApiPost(api?.global_search, body)
    .then((response) => response?.data)
});

// Organisation CRUD
export const create_organisation = createAsyncThunk("create_organisation", async (body) => {
  return ApiPost(api?.create_organisation, body)
    .then((response) => response?.data)
});

export const get_organisations = createAsyncThunk("get_organisations", async (body) => {
  return ApiPost(api?.get_organisations, body)
    .then((response) => response?.data)
});

export const get_organisation_by_id = createAsyncThunk("get_organisation_by_id", async (body) => {
  return ApiPost(api?.get_organisation_by_id, body)
    .then((response) => response?.data)
});

export const update_organisation = createAsyncThunk("update_organisation", async (body) => {
  return ApiPut(api?.update_organisation, body)
    .then((response) => response?.data)
});

export const delete_organisation = createAsyncThunk("delete_organisation", async (body) => {
  return ApiPost(api?.delete_organisation, body)
    .then((response) => response?.data)
});

export const add_organisation_admin = createAsyncThunk("add_organisation_admin", async (body) => {
  return ApiPost(api?.add_organisation_admin, body)
    .then((response) => response?.data)
});

export const remove_organisation_admin = createAsyncThunk("remove_organisation_admin", async (body) => {
  return ApiPost(api?.remove_organisation_admin, body)
    .then((response) => response?.data)
});

export const get_organisation_roles = createAsyncThunk("get_organisation_roles", async (body) => {
  return ApiPost(api?.get_organisation_roles, body)
    .then((response) => response?.data)
});

export const create_organisation_role = createAsyncThunk("create_organisation_role", async (body) => {
  return ApiPost(api?.create_organisation_role, body)
    .then((response) => response?.data)
});

// Bulk Import
export const get_bulk_import_template = createAsyncThunk("get_bulk_import_template", async () => {
  return ApiGet(api?.get_bulk_import_template)
    .then((response) => response?.data)
});

export const validate_bulk_import = createAsyncThunk("validate_bulk_import", async (body) => {
  return ApiPost(api?.validate_bulk_import, body)
    .then((response) => response?.data)
});

export const bulk_import_members = createAsyncThunk("bulk_import_members", async (body) => {
  return ApiPost(api?.bulk_import_members, body)
    .then((response) => response?.data)
});

export const move_users_to_org = createAsyncThunk("move_users_to_org", async (body) => {
  return ApiPost(api?.move_users_to_org, body)
    .then((response) => response?.data)
});

export const migrate_org_member_statuses = createAsyncThunk("migrate_org_member_statuses", async (body) => {
  return ApiPost(api?.migrate_org_member_statuses, body)
    .then((response) => response?.data)
});

export const get_import_history = createAsyncThunk("get_import_history", async (body) => {
  return ApiPost(api?.get_import_history, body)
    .then((response) => response?.data)
});

export const get_organisation_payment_request = createAsyncThunk(
  "get_organisation_payment_request",
  async (body) => {
    return ApiPost(api?.get_organisation_payment_request, body)
      .then((response) => response?.data)
  }
);

export const approve_organisation_paymentRequest = createAsyncThunk(
  "approve_organisation_paymentRequest",
  async (body) => {
    return ApiPost(api?.approve_organisation_paymentRequest, body)
      .then((response) => response?.data)
  }
);

export const create_organisation_paymentRequest = createAsyncThunk(
  "create_organisation_paymentRequest",
  async (body) => {
    return ApiPost(api?.create_organisation_paymentRequest, body)
      .then((response) => response?.data)
  }
);

export const get_organisation_claims = createAsyncThunk(
  "get_organisation_claims",
  async (body) => {
    return ApiPost(api?.get_organisation_claims, body)
      .then((response) => response?.data)
  }
);

export const update_claim_stage = createAsyncThunk(
  "update_claim_stage",
  async (body) => {
    return ApiPost(api?.update_claim_stage, body)
      .then((response) => response?.data)
  }
);

export const add_user_transaction = createAsyncThunk(
  "add_user_transaction",
  async (body) => {
    return ApiPost(api?.add_user_transaction, body)
      .then((response) => response?.data)
  }
);

export const download_transaction_receipt = createAsyncThunk(
  "download_transaction_receipt",
  async (body) => {
    return ApiPost(api?.download_transaction_receipt, body)
      .then((response) => response?.data)
  }
);

// Check Transaction Status from ICICI API
export const check_transaction_status = createAsyncThunk(
  "check_transaction_status",
  async (body) => {
    return ApiPost(api?.check_transaction_status, body)
      .then((response) => response?.data)
  }
);

export const aadhar_send_otp = createAsyncThunk(
  "aadhar_send_otp",
  async (body) => {
    return ApiPost(api?.aadhar_send_otp, body)
      .then((response) => response?.data)
  }
);

export const aadhar_verify_otp = createAsyncThunk(
  "aadhar_verify_otp",
  async (body) => {
    return ApiPost(api?.aadhar_verify_otp, body)
      .then((response) => response?.data)
  }
);

export const id_proof_verification = createAsyncThunk(
  "id_proof_verification",
  async (body) => {
    return ApiPost(api?.id_proof_verification, body)
      .then((response) => response?.data)
  }
);

export const get_payment_receipt = createAsyncThunk(
  "get_payment_receipt",
  async (body) => {
    return ApiPost(api?.get_payment_receipt, body)
      .then((response) => response?.data)
  }
);

export const api_config = createAsyncThunk("api_config", async () => {
  return ApiGet(api?.api_config)
    .then((response) => response?.data)
});

export const update_config   = createAsyncThunk(
  "update_config",
  async (body) => {
    return ApiPost(api?.update_config, body)
      .then((response) => response?.data)
  }
);


// -----------------------------------  News & Banner  -----------------------------------

// //get Event
export const get_posts = createAsyncThunk("get_posts", async (body) => {
  return ApiPost(api?.get_posts, body)
    .then((response) => response?.data)
});

// //add Event
export const create_posts = createAsyncThunk("create_posts", async (body) => {
  return ApiPost(api?.create_posts, body)
    .then((response) => response?.data)
});

// //update Event
export const update_post = createAsyncThunk("update_post", async (body) => {
  return ApiPost(api?.update_post, body)
    .then((response) => response?.data)
});

// //delete Event
export const delete_post = createAsyncThunk("delete_post", async (body) => {
  return ApiPost(api?.delete_post, body)
    .then((response) => response?.data)
});

export const copy_mobile_banners_to_website = createAsyncThunk("copy_mobile_banners_to_website", async () => {
  return ApiPost(api?.copy_mobile_banners_to_website, {})
    .then((response) => response?.data)
});

export const reorder_hero_banners = createAsyncThunk("reorder_hero_banners", async (body) => {
  return ApiPost(api?.reorder_hero_banners, body)
    .then((response) => response?.data)
});

export const get_core_team_options = createAsyncThunk("get_core_team_options", async (body = {}) => {
  return ApiPost(api?.get_core_team_options, body)
    .then((response) => response?.data)
});

export const create_core_team_option = createAsyncThunk("create_core_team_option", async (body) => {
  return ApiPost(api?.create_core_team_option, body)
    .then((response) => response?.data)
});

export const update_core_team_option = createAsyncThunk("update_core_team_option", async (body) => {
  return ApiPost(api?.update_core_team_option, body)
    .then((response) => response?.data)
});

export const delete_core_team_option = createAsyncThunk("delete_core_team_option", async (body) => {
  return ApiPost(api?.delete_core_team_option, body)
    .then((response) => response?.data)
});

export const createPrivacyPolicyAndTermsAndCondition = createAsyncThunk("createPrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.createPrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
});

export const getPrivacyPolicyAndTermsAndCondition = createAsyncThunk("getPrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.getPrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
});

export const get_contactUs = createAsyncThunk("get_contactUs", async (body) => {
  return ApiPost(api?.get_contactUs, body)
    .then((response) => response?.data)
});

export const delete_contactUs = createAsyncThunk("delete_contactUs", async (body) => {
  return ApiPost(api?.delete_contactUs, body)
    .then((response) => response?.data)
});

export const updatePrivacyPolicyAndTermsAndCondition = createAsyncThunk("updatePrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.updatePrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
});

export const getMemberByPhoneNumber = createAsyncThunk("getMemberByPhoneNumber", async (body) => {
  return ApiPost(api?.getMemberByPhoneNumber, body)
    .then((response) => response?.data)
});

export const getTicket = createAsyncThunk("getTicket", async (body) => {
  return ApiPost(api?.getTicket, body)
    .then((response) => response?.data)
});

export const getTicketById = createAsyncThunk("getTicketById", async (body) => {
  return ApiPost(api?.getTicketById, body)
    .then((response) => response?.data)
});

export const getTicketStats = createAsyncThunk("getTicketStats", async (body) => {
  return ApiPost(api?.getTicketStats, body)
    .then((response) => response?.data)
});

export const getTicketConfig = createAsyncThunk("getTicketConfig", async (body) => {
  return ApiPost(api?.getTicketConfig, body)
    .then((response) => response?.data)
});

export const updateTicket = createAsyncThunk("updateTicket", async (body) => {
  return ApiPost(api?.updateTicket, body)
    .then((response) => response?.data)
});

export const addTicketReply = createAsyncThunk("addTicketReply", async (body) => {
  return ApiPost(api?.addTicketReply, body)
    .then((response) => response?.data)
});

export const deleteTicket = createAsyncThunk("deleteTicket", async (body) => {
  return ApiPost(api?.deleteTicket, body)
    .then((response) => response?.data)
});

export const get_members_report = createAsyncThunk("get_members_report", async (body) => {
  return ApiPost(api?.get_members_report, body)
    .then((response) => response?.data)
});

export const getAllEligibleMembers = createAsyncThunk("getAllEligibleMembers", async (body) => {
  return ApiPost(api?.getAllEligibleMembers, body)
    .then((response) => response?.data)
});

export const getAllClaims = createAsyncThunk("getAllClaims", async (body) => {
  return ApiPost(api?.getAllClaims, body)
    .then((response) => response?.data)
});

// Reference/Referral Tracking
export const getTopReferrers = createAsyncThunk("getTopReferrers", async (params) => {
  const queryString = new URLSearchParams(params).toString();
  return ApiGet(`${api?.getTopReferrers}?${queryString}`)
    .then((response) => response?.data)
});

export const getReferredMembers = createAsyncThunk("getReferredMembers", async ({ phoneNumber, params }) => {
  const queryString = new URLSearchParams(params).toString();
  return ApiGet(`${api?.getReferredMembers}${phoneNumber}?${queryString}`)
    .then((response) => response?.data)
});

export const getReferenceStats = createAsyncThunk("getReferenceStats", async () => {
  return ApiGet(api?.getReferenceStats)
    .then((response) => response?.data)
});

export const updateClaim = createAsyncThunk("updateClaim", async (body) => {
  return ApiPost(api?.updateClaim, body)
    .then((response) => response?.data)
});

// Enhanced Claims (Stage-based)
export const getEnhancedClaims = createAsyncThunk("getEnhancedClaims", async (params) => {
  const queryString = new URLSearchParams(params).toString();
  return ApiGet(`${api?.getEnhancedClaims}?${queryString}`)
    .then((response) => response?.data)
});

export const getEnhancedClaimDetails = createAsyncThunk("getEnhancedClaimDetails", async (id) => {
  return ApiGet(`${api?.getEnhancedClaimDetails}${id}`)
    .then((response) => response?.data)
});

export const moveClaimStage = createAsyncThunk("moveClaimStage", async (body) => {
  return ApiPost(api?.moveClaimStage, body)
    .then((response) => response?.data)
});

export const adminNotifyDeath = createAsyncThunk("adminNotifyDeath", async (body) => {
  return ApiPost(api?.adminNotifyDeath, body)
    .then((response) => response?.data)
});

export const createaboutUs = createAsyncThunk("createaboutUs", async (body) => {
  return ApiPost(api?.createaboutUs, body)
    .then((response) => response?.data)
});

export const updateaboutUs = createAsyncThunk("updateaboutUs", async (body, id) => {
  return ApiPost(`${api?.updateaboutUs}/${body?.id}`, body)
    .then((response) => response?.data)
});

export const getallaboutUs = createAsyncThunk("getallaboutUs", async (body) => {
  return ApiGet(api?.getallaboutUs, body)
    .then((response) => response?.data)
});

export const getallpressandmediacoverage = createAsyncThunk("getallpressandmediacoverage", async (body) => {
  return ApiGet(api?.getallpressandmediacoverage, body)
    .then((response) => response?.data)
});

export const createpressandmediacoverage = createAsyncThunk("createpressandmediacoverage", async (body) => {
  return ApiPost(api?.createpressandmediacoverage, body)
    .then((response) => response?.data)
});

export const updatepressandmediacoverage = createAsyncThunk("updatepressandmediacoverage", async (body, id) => {
  return ApiPost(`${api?.updatepressandmediacoverage}/${body?.id}`, body)
    .then((response) => response?.data)
});

export const getallpress = createAsyncThunk("getallpress", async (body) => {
  return ApiPost(api?.getallpress, body)
    .then((response) => response?.data)
});

export const createpress = createAsyncThunk("createpress", async (body) => {
  return ApiPost(api?.createpress, body)
    .then((response) => response?.data)
});

export const updatepress = createAsyncThunk("updatepress", async (body, id) => {
  return ApiPost(`${api?.updatepress}`, body)
    .then((response) => response?.data)
});

export const deletepress = createAsyncThunk("deletepress", async (body) => {
  return ApiPost(api?.deletepress, body)
    .then((response) => response?.data)
});

// -----------------------------------  Public Landing Page APIs (No Auth Required)  -----------------------------------

// Helper to extract serializable error data
const getSerializableError = (error) => ({
  message: error?.message || error?.data?.message || 'An error occurred',
  status: error?.status || error?.data?.status || 500,
  data: error?.data || null
});

// ========== PUBLIC WEBSITE APIs (New dedicated endpoints) ==========

// Get hero banners (public) - params: { page, limit, status }
export const get_posts_public = createAsyncThunk("get_posts_public", async (body) => {
  // Backward compatible: routes through new public API based on type
  const { type, status, page, limit, memberType } = body || {};
  let url = "";
  if (type === "Hero-Banner") {
    url = `${api?.public_getHeroBanners}?page=${page || 1}&limit=${limit || 10}${status ? `&status=${status}` : ""}`;
  } else if (type === "Mobile-Hero-Banner") {
    url = `${api?.public_getMobileHeroBanners}?page=${page || 1}&limit=${limit || 10}${status ? `&status=${status}` : ""}`;
  } else if (type === "News-Events") {
    url = `${api?.public_getEvents}?page=${page || 1}&limit=${limit || 10}${status ? `&status=${status}` : ""}`;
  } else if (type === "Office-Member") {
    url = `${api?.public_getOfficeMembers}?page=${page || 1}&limit=${limit || 50}${memberType ? `&type=${memberType}` : ""}`;
  } else {
    // Fallback to old admin endpoint for unknown types
    return ApiPostNoAuth(api?.get_posts, body)
      .then((response) => response?.data)
      .catch((error) => getSerializableError(error));
  }
  return ApiGetNoAuth(url)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get core team types (public)
export const getCoreTeamTypes_public = createAsyncThunk("getCoreTeamTypes_public", async () => {
  return ApiGetNoAuth(api?.public_getCoreTeamTypes)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get about us (public)
export const getallaboutUs_public = createAsyncThunk("getallaboutUs_public", async () => {
  return ApiGetNoAuth(api?.public_getAboutUs)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get privacy policy (public)
export const getPrivacyPolicyAndTermsAndCondition_public = createAsyncThunk("getPrivacyPolicyAndTermsAndCondition_public", async (body) => {
  const { type } = body || {};
  const url = type === "Terms-Conditions" ? api?.public_getTermsAndConditions : api?.public_getPrivacyPolicy;
  return ApiGetNoAuth(url)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get press and media coverage (public)
export const getallpressandmediacoverage_public = createAsyncThunk("getallpressandmediacoverage_public", async () => {
  return ApiGetNoAuth(api?.public_getPressAndMedia)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get press (public) — falls back to unauthenticated admin endpoint if public route is unavailable
export const getallpress_public = createAsyncThunk("getallpress_public", async (params) => {
  const { page = 1, limit = 50 } = params || {};
  const publicUrl = `${api?.public_getPress}?page=${page}&limit=${limit}`;

  try {
    const response = await ApiGetNoAuth(publicUrl);
    return response?.data;
  } catch (error) {
    try {
      const fallback = await ApiPostNoAuth(api?.getallpress, { page, limit });
      return fallback?.data;
    } catch (fallbackError) {
      return getSerializableError(error);
    }
  }
});

// Get post/event by ID (public)
export const get_post_by_id_public = createAsyncThunk("get_post_by_id_public", async (body) => {
  const { _id } = body || {};
  return ApiGetNoAuth(`${api?.public_getEventById}${_id}`)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get website stats for Impact Counter (public)
export const getWebsiteStats_public = createAsyncThunk("getWebsiteStats_public", async () => {
  return ApiGetNoAuth(api?.public_getWebsiteStats)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Get FAQs (public)
export const getFaq_public = createAsyncThunk("getFaq_public", async () => {
  return ApiGetNoAuth(api?.public_getFaq)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// Submit contact form (public)
export const submitContactUs_public = createAsyncThunk("submitContactUs_public", async (body) => {
  return ApiPostNoAuth(api?.public_submitContactUs, body)
    .then((response) => response?.data)
    .catch((error) => getSerializableError(error));
});

// -----------------------------------  SMS Gateway Settings  -----------------------------------

export const getSmsGateway = createAsyncThunk("getSmsGateway", async () => {
  return ApiGet(api?.getSmsGateway)
    .then((response) => response?.data)
});

export const updateSmsGateway = createAsyncThunk("updateSmsGateway", async (body) => {
  return ApiPut(api?.updateSmsGateway, body)
    .then((response) => response?.data)
});

// -----------------------------------  Age Wise Payment Settings  -----------------------------------

export const getAgeGroup = createAsyncThunk("getAgeGroup", async () => {
  return ApiGet(api?.getAgeGroup)
    .then((response) => {
      console.log('[getAgeGroup] Raw response:', response);
      return response?.data;
    })
    .catch((error) => {
      console.error('[getAgeGroup] Error:', error);
      return error;
    });
});

export const createAgeGroup = createAsyncThunk("createAgeGroup", async (body) => {
  return ApiPost(api?.createAgeGroup, body)
    .then((response) => response?.data)
});

export const updateAgeGroup = createAsyncThunk("updateAgeGroup", async (body) => {
  return ApiPut(api?.updateAgeGroup, body)
    .then((response) => response?.data)
});

export const updateSingleAgeGroup = createAsyncThunk("updateSingleAgeGroup", async (body) => {
  return ApiPut(api?.updateSingleAgeGroup, body)
    .then((response) => response?.data)
});

export const deleteAgeGroup = createAsyncThunk("deleteAgeGroup", async (id) => {
  return ApiDelete(api?.deleteAgeGroup + id)
    .then((response) => response?.data)
});

// ==================== IMPROVEMENT APIs (v2) ====================

// -----------------------------------  Stage Management  -----------------------------------

export const getStages = createAsyncThunk("getStages", async () => {
  return ApiGet(api?.getStages)
    .then((response) => response?.data)
});

export const createRegistrationStage = createAsyncThunk("createRegistrationStage", async (body) => {
  return ApiPost(api?.createRegistrationStage, body)
    .then((response) => response?.data)
});

export const updateRegistrationStage = createAsyncThunk("updateRegistrationStage", async ({ stageKey, body }) => {
  return ApiPut(api?.updateRegistrationStage + stageKey, body)
    .then((response) => response?.data)
});

export const deleteRegistrationStage = createAsyncThunk("deleteRegistrationStage", async ({ stageKey, body }) => {
  return ApiDelete(api?.deleteRegistrationStage + stageKey, body)
    .then((response) => response?.data)
});

export const reorderStages = createAsyncThunk("reorderStages", async (body) => {
  return ApiPost(api?.reorderStages, body)
    .then((response) => response?.data)
});

export const transitionUserStage = createAsyncThunk("transitionUserStage", async (body) => {
  return ApiPost(api?.transitionUserStage, body)
    .then((response) => response?.data)
});

export const getUserStageProgress = createAsyncThunk("getUserStageProgress", async (userId) => {
  return ApiGet(api?.getUserStageProgress + userId + "/progress")
    .then((response) => response?.data)
});

// -----------------------------------  Referral Management  -----------------------------------

export const getReferralConfig = createAsyncThunk("getReferralConfig", async () => {
  return ApiGet(api?.getReferralConfig)
    .then((response) => response?.data)
});

export const updateReferralConfig = createAsyncThunk("updateReferralConfig", async (body) => {
  return ApiPut(api?.updateReferralConfig, body)
    .then((response) => response?.data)
});

export const getAllReferrals = createAsyncThunk("getAllReferrals", async (body) => {
  return ApiPost(api?.getAllReferrals, body)
    .then((response) => response?.data)
});

export const getReferralLeaderboard = createAsyncThunk("getReferralLeaderboard", async (body) => {
  return ApiPost(api?.getReferralLeaderboard, body)
    .then((response) => response?.data)
});

export const migrateReferrals = createAsyncThunk("migrateReferrals", async () => {
  return ApiPost(api?.migrateReferrals)
    .then((response) => response?.data)
});

// -----------------------------------  System Management  -----------------------------------

export const getAuditLogs = createAsyncThunk("getAuditLogs", async (body) => {
  return ApiPost(api?.getAuditLogs, body)
    .then((response) => response?.data)
});

export const getAuditLogDetail = createAsyncThunk("getAuditLogDetail", async (body) => {
  return ApiPost(api?.getAuditLogDetail, body)
    .then((response) => response?.data)
});

export const getActivitySummary = createAsyncThunk("getActivitySummary", async (body) => {
  return ApiPost(api?.getActivitySummary, body)
    .then((response) => response?.data)
});

export const getCacheStats = createAsyncThunk("getCacheStats", async () => {
  return ApiGet(api?.getCacheStats)
    .then((response) => response?.data)
});

export const clearCache = createAsyncThunk("clearCache", async (body) => {
  return ApiPost(api?.clearCache, body)
    .then((response) => response?.data)
});

export const getStatusSummary = createAsyncThunk("getStatusSummary", async () => {
  return ApiGet(api?.getStatusSummary)
    .then((response) => response?.data)
});

export const getPaymentStats = createAsyncThunk("getPaymentStats", async () => {
  return ApiGet(api?.getPaymentStats)
    .then((response) => response?.data)
});

export const getSystemHealth = createAsyncThunk("getSystemHealth", async () => {
  return ApiGet(api?.getSystemHealth)
    .then((response) => response?.data)
});

export const triggerReminders = createAsyncThunk("triggerReminders", async () => {
  return ApiPost(api?.triggerReminders)
    .then((response) => response?.data)
});

export const runMigration = createAsyncThunk("runMigration", async (body) => {
  return ApiPost(api?.runMigration, body)
    .then((response) => response?.data)
});

export const runSeeds = createAsyncThunk("runSeeds", async (body) => {
  return ApiPost(api?.runSeeds, body)
    .then((response) => response?.data)
});

export const seedSRKOrganisation = createAsyncThunk("seedSRKOrganisation", async (body) => {
  return ApiPost(api?.seedSRKOrganisation, body)
    .then((response) => response?.data)
});

export const getExpiringPolicies = createAsyncThunk("getExpiringPolicies", async (body) => {
  return ApiPost(api?.getExpiringPolicies, body)
    .then((response) => response?.data)
});

// -----------------------------------  Reminder Module  -----------------------------------

export const getRenewalList = createAsyncThunk("getRenewalList", async (body) => {
  return ApiPost(api?.getRenewalList, body)
    .then((response) => response?.data)
});

export const getMemberRenewalDetails = createAsyncThunk("getMemberRenewalDetails", async (id) => {
  return ApiGet(api?.getMemberRenewalDetails + id)
    .then((response) => response?.data)
});

export const sendWhatsAppReminder = createAsyncThunk("sendWhatsAppReminder", async (body) => {
  return ApiPost(api?.sendWhatsAppReminder, body)
    .then((response) => response?.data)
});

export const sendBulkReminders = createAsyncThunk("sendBulkReminders", async (body) => {
  return ApiPost(api?.sendBulkReminders, body)
    .then((response) => response?.data)
});

export const getReminderHistory = createAsyncThunk("getReminderHistory", async (userId) => {
  return ApiGet(api?.getReminderHistory + userId)
    .then((response) => response?.data)
});

export const getReminderStats = createAsyncThunk("getReminderStats", async () => {
  return ApiGet(api?.getReminderStats)
    .then((response) => response?.data)
});

export const exportRenewalList = createAsyncThunk("exportRenewalList", async (body) => {
  return ApiPostText(api?.exportRenewalList, body)
    .then((response) => response?.data)
});

// Renewal Template Reminders (Meta Approved WhatsApp Templates)
export const getRenewalTemplates = createAsyncThunk("getRenewalTemplates", async () => {
  return ApiGet(api?.getRenewalTemplates)
    .then((response) => response?.data)
});

export const sendRenewalTemplateReminder = createAsyncThunk("sendRenewalTemplateReminder", async (body) => {
  return ApiPost(api?.sendRenewalTemplateReminder, body)
    .then((response) => response?.data)
});

export const sendBulkTemplateReminders = createAsyncThunk("sendBulkTemplateReminders", async (body) => {
  return ApiPost(api?.sendBulkTemplateReminders, body)
    .then((response) => response?.data)
});

// ==================== EXPENSE MODULE ====================

// Expense CRUD
export const createExpense = createAsyncThunk("createExpense", async (body) => {
  return ApiPost(api?.createExpense, body)
    .then((response) => response?.data)
});

export const getExpenses = createAsyncThunk("getExpenses", async (body) => {
  return ApiPost(api?.getExpenses, body)
    .then((response) => response?.data)
});

export const getExpenseById = createAsyncThunk("getExpenseById", async (id) => {
  return ApiGet(api?.getExpenseById + id)
    .then((response) => response?.data)
});

export const updateExpense = createAsyncThunk("updateExpense", async (body) => {
  return ApiPut(api?.updateExpense, body)
    .then((response) => response?.data)
});

export const deleteExpense = createAsyncThunk("deleteExpense", async (id) => {
  return ApiDelete(api?.deleteExpense + id)
    .then((response) => response?.data)
});

// Expense Approval
export const approveExpense = createAsyncThunk("approveExpense", async (body) => {
  return ApiPost(api?.approveExpense, body)
    .then((response) => response?.data)
});

export const rejectExpense = createAsyncThunk("rejectExpense", async (body) => {
  return ApiPost(api?.rejectExpense, body)
    .then((response) => response?.data)
});

export const bulkApproveExpenses = createAsyncThunk("bulkApproveExpenses", async (body) => {
  return ApiPost(api?.bulkApproveExpenses, body)
    .then((response) => response?.data)
});

export const bulkRejectExpenses = createAsyncThunk("bulkRejectExpenses", async (body) => {
  return ApiPost(api?.bulkRejectExpenses, body)
    .then((response) => response?.data)
});

export const getPendingExpenses = createAsyncThunk("getPendingExpenses", async (body) => {
  return ApiPost(api?.getPendingExpenses, body)
    .then((response) => response?.data)
});

// Expense Dashboard
export const getExpenseDashboard = createAsyncThunk("getExpenseDashboard", async () => {
  return ApiGet(api?.getExpenseDashboard)
    .then((response) => response?.data)
});

// Expense Categories
export const createExpenseCategory = createAsyncThunk("createExpenseCategory", async (body) => {
  return ApiPost(api?.createExpenseCategory, body)
    .then((response) => response?.data)
});

export const getExpenseCategories = createAsyncThunk("getExpenseCategories", async (body) => {
  return ApiPost(api?.getExpenseCategories, body || {})
    .then((response) => response?.data)
});

export const updateExpenseCategory = createAsyncThunk("updateExpenseCategory", async (body) => {
  return ApiPut(api?.updateExpenseCategory, body)
    .then((response) => response?.data)
});

export const deleteExpenseCategory = createAsyncThunk("deleteExpenseCategory", async (id) => {
  return ApiDelete(api?.deleteExpenseCategory + id)
    .then((response) => response?.data)
});

export const seedExpenseCategories = createAsyncThunk("seedExpenseCategories", async () => {
  return ApiPost(api?.seedExpenseCategories, {})
    .then((response) => response?.data)
});

// Expense Reports
export const getMonthlyExpenseReport = createAsyncThunk("getMonthlyExpenseReport", async (body) => {
  return ApiPost(api?.getMonthlyExpenseReport, body)
    .then((response) => response?.data)
});

export const getCategoryExpenseReport = createAsyncThunk("getCategoryExpenseReport", async (body) => {
  return ApiPost(api?.getCategoryExpenseReport, body)
    .then((response) => response?.data)
});

export const getCustomExpenseReport = createAsyncThunk("getCustomExpenseReport", async (body) => {
  return ApiPost(api?.getCustomExpenseReport, body)
    .then((response) => response?.data)
});

export const getDailyExpenseExport = createAsyncThunk("getDailyExpenseExport", async (body) => {
  return ApiPost(api?.getDailyExpenseExport, body)
    .then((response) => response?.data)
});

export const saveExpenseReport = createAsyncThunk("saveExpenseReport", async (body) => {
  return ApiPost(api?.saveExpenseReport, body)
    .then((response) => response?.data)
});

export const getExpenseReportHistory = createAsyncThunk("getExpenseReportHistory", async (body) => {
  return ApiPost(api?.getExpenseReportHistory, body)
    .then((response) => response?.data)
});

// -----------------------------------  WhatsApp Templates  -----------------------------------

export const sendWhatsAppToMember = createAsyncThunk("sendWhatsAppToMember", async (body) => {
  return ApiPost(api?.sendWhatsAppToMember, body)
    .then((response) => response?.data)
});

export const getWhatsAppTemplatesList = createAsyncThunk("getWhatsAppTemplatesList", async () => {
  return ApiGet(api?.getWhatsAppTemplates)
    .then((response) => response?.data)
});

export const testWhatsAppTemplateAction = createAsyncThunk("testWhatsAppTemplateAction", async (body) => {
  return ApiPost(api?.testWhatsAppTemplate, body)
    .then((response) => response?.data)
});

export const markAsDeceased = createAsyncThunk("markAsDeceased", async (body) => {
  return ApiPost(api?.markAsDeceased, body)
    .then((response) => response?.data)
});

export const markAsOptedOut = createAsyncThunk("markAsOptedOut", async (body) => {
  return ApiPost(api?.markAsOptedOut, body)
    .then((response) => response?.data)
});

// ==================== POST GENERATOR MODULE ====================

export const createPostCategory = createAsyncThunk("createPostCategory", async (body) => {
  return ApiPost(api?.createPostCategory, body)
    .then((response) => response?.data)
});

export const getPostCategories = createAsyncThunk("getPostCategories", async (body) => {
  return ApiPost(api?.getPostCategories, body)
    .then((response) => response?.data)
});

export const updatePostCategory = createAsyncThunk("updatePostCategory", async (body) => {
  return ApiPut(api?.updatePostCategory, body)
    .then((response) => response?.data)
});

export const deletePostCategory = createAsyncThunk("deletePostCategory", async (id) => {
  return ApiDelete(api?.deletePostCategory + id)
    .then((response) => response?.data)
});

export const createPostTemplate = createAsyncThunk("createPostTemplate", async (body) => {
  return ApiPost(api?.createPostTemplate, body)
    .then((response) => response?.data)
});

export const getPostTemplates = createAsyncThunk("getPostTemplates", async (body) => {
  return ApiPost(api?.getPostTemplates, body)
    .then((response) => response?.data)
});

export const getPostTemplateById = createAsyncThunk("getPostTemplateById", async (id) => {
  return ApiGet(api?.getPostTemplateById + id)
    .then((response) => response?.data)
});

export const updatePostTemplate = createAsyncThunk("updatePostTemplate", async (body) => {
  return ApiPut(api?.updatePostTemplate, body)
    .then((response) => response?.data)
});

export const deletePostTemplate = createAsyncThunk("deletePostTemplate", async (id) => {
  return ApiDelete(api?.deletePostTemplate + id)
    .then((response) => response?.data)
});

export const getPostGeneratorStats = createAsyncThunk("getPostGeneratorStats", async () => {
  return ApiGet(api?.getPostGeneratorStats)
    .then((response) => response?.data)
});

export const seedPostCategories = createAsyncThunk("seedPostCategories", async () => {
  return ApiPost(api?.seedPostCategories, {})
    .then((response) => response?.data)
});